import React, {useState} from "react";
import {Box, Button, TextInput} from "@mantine/core";
import classes from "./SubjectsPanel.module.css";

export interface NameModalBodyProps {
    initialName?: string;
    onConfirm: (name: string) => Promise<void> | void;
    onCancel?: () => void;
    loading: boolean;
    confirmTestId?: string;
    submitLabel?: string;
}

export const NameModalBody: React.FC<NameModalBodyProps> = ({
    initialName,
    onConfirm,
    onCancel,
    loading,
    confirmTestId,
    submitLabel,
}) => {
    const [name, setName] = useState(initialName ?? "");
    return (
        <Box className={classes.modalContent}>
            <TextInput
                label="Name"
                maxLength={100}
                value={name}
                onChange={(e) => setName(e.currentTarget.value)}
            />
            <Box className={classes.modalButtons}>
                <Button variant="default" disabled={loading} onClick={onCancel}>
                    Cancel
                </Button>
                <Box/>
                <Button
                    data-testid={confirmTestId}
                    loading={loading}
                    onClick={() => onConfirm(name)}
                >
                    {submitLabel ?? "Confirm"}
                </Button>
            </Box>
        </Box>
    );
};